
const state = {
  menuInfo: {}
}

const actions = {
  updateMenu (ctx, item) {
    ctx.commit('updateMenu', item)
  }
}

const mutations = {
  updateMenu (state, item) {
    state.menuInfo = item
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
